import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetRelatedAuctionsParams,
  ApiGetRelatedDirectSalesParams,
  BackendErrorEntity,
  GetRelatedAuctionsResponseDto,
  GetRelatedDirectSalesResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetRelatedAuctions = (
    params?: MaybeRef<ApiGetRelatedAuctionsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetRelatedAuctionsResponseDto>(
      {url: `/related/auctions`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetRelatedAuctionsQueryKey = (params?: MaybeRef<ApiGetRelatedAuctionsParams>,) => {
    return ['related','auctions', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetRelatedAuctionsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetRelatedAuctions>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetRelatedAuctionsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedAuctions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetRelatedAuctionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetRelatedAuctions>>> = () => apiGetRelatedAuctions(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedAuctions>>, TError, TData> 
}

export type ApiGetRelatedAuctionsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetRelatedAuctions>>>
export type ApiGetRelatedAuctionsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetRelatedAuctions<TData = Awaited<ReturnType<typeof apiGetRelatedAuctions>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetRelatedAuctionsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedAuctions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetRelatedAuctionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetRelatedDirectSales = (
    params?: MaybeRef<ApiGetRelatedDirectSalesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetRelatedDirectSalesResponseDto>(
      {url: `/related/directSales`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetRelatedDirectSalesQueryKey = (params?: MaybeRef<ApiGetRelatedDirectSalesParams>,) => {
    return ['related','directSales', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetRelatedDirectSalesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetRelatedDirectSales>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetRelatedDirectSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedDirectSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetRelatedDirectSalesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetRelatedDirectSales>>> = () => apiGetRelatedDirectSales(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedDirectSales>>, TError, TData> 
}

export type ApiGetRelatedDirectSalesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetRelatedDirectSales>>>
export type ApiGetRelatedDirectSalesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetRelatedDirectSales<TData = Awaited<ReturnType<typeof apiGetRelatedDirectSales>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetRelatedDirectSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetRelatedDirectSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetRelatedDirectSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



